interface NamedLecturer {
    firstName: string;
    lastName: string;
}

const HEBREW_START = /^\s*[֐-׿]/;
const isHebrew = (s: string) => HEBREW_START.test(s);

export function compareLecturerName<T extends NamedLecturer>(a: T, b: T): number {
    const aSortName = a.lastName || a.firstName;
    const bSortName = b.lastName || b.firstName;
    const aHe = isHebrew(aSortName);
    const bHe = isHebrew(bSortName);
    if(aHe !== bHe) return aHe ? -1 : 1;

    const aHasLast = !!a.lastName;
    const bHasLast = !!b.lastName;
    if(aHasLast !== bHasLast) return aHasLast ? -1 : 1;

    const locale = aHe ? 'he' : 'en';
    return aSortName.localeCompare(bSortName, locale, {sensitivity: 'base'})
        || (aHasLast ? a.firstName.localeCompare(b.firstName, locale, {sensitivity: 'base'}) : 0);
}

export function sortLecturers<T extends NamedLecturer>(lecturers: readonly T[]): T[] {
    return [...lecturers].sort(compareLecturerName);
}
